const iv = 20190101
const requestKey = 'Zmr密钥Dct!#'
const url = 'http://127.0.0.1:500/'

export default {
  iv,
  requestKey,
  url
}



//////////////////
// WEBPACK FOOTER
// ./static/js/Constant.js
// module id = null
// module chunks = 